export default "__VITE_ASSET__De48_jCU__"